module.exports = __webpack_public_path__ + "img/banner_joinstocknews.92c3f15.png";